import React from 'react';

type NextIconProps = {
  height?: string;
  width?: string;
  color?: string;
};

function NextIcon({
  height = '16',
  width = '16',
  color = 'white',
}: NextIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1 8L15 8M15 8L8 1M15 8L8 15'
        stroke={color}
        strokeWidth='2'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  );
}

export default NextIcon;
